import { Article } from '@wix/answers-api';
import { Box, Heading, Collapse, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent, useState } from 'react';

import { FollowedContentList } from './FollowedContentList';
import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

export type FollowedContentProps = {
  followedContent: Article[];
  followedContentCount: number;
  unfollowContnet: (articleId: string) => void;
  onShowMoreClick: () => void;
};

export const FollowedContent: FunctionComponent<FollowedContentProps> = ({
  followedContent,
  followedContentCount,
  unfollowContnet,
  onShowMoreClick,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { t } = useTranslation();
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  const hasMore = followedContent.length < followedContentCount;
  return (
    <Box
      direction="vertical"
      dataHook={DATA_HOOKS.MY_ACTIVITY_FOLLOWED_CONTENT}
      className={
        isCollapsed
          ? `${css.collapsedList} ${css.collapsed}`
          : `${css.collapsedList}`
      }
    >
      <Heading
        dataHook={DATA_HOOKS.MY_ACTIVITY_FOLLOWED_CONTENT_TITLE}
        className={css.followedContentTitle}
        onClick={toggleCollapse}
      >
        <div className={css.toggleArrow} />
        {t('user.my-activity.followed.content')}
        <span>({followedContentCount})</span>
      </Heading>
      <Collapse open={!isCollapsed}>
        {followedContent.length ? (
          <FollowedContentList
            unfollowContnet={unfollowContnet}
            followedContent={followedContent}
          />
        ) : (
          !hasMore && <p className={css.none}>
            {t('user.my-activity.no.followed.content')}
          </p>
        )}
        {hasMore ? (
          <TextButton
            dataHook={DATA_HOOKS.MY_ACTIVITY_FOLLOWED_CONTENT_SHOW_MORE}
            onClick={onShowMoreClick}
            className={css.more}
          >
            {t('user.my-activity.show.more')}
          </TextButton>
        ) : null}
      </Collapse>
    </Box>
  );
};
